import { ProductCardStructure } from 'common/components';
import { ENTRANCE_DOORS_CDN_PATH } from 'landings/entrance-doors/entrance-doors-constants';

export type SpecialDoorStructure = {
  text: string;
} & ProductCardStructure;

export const ENTRANCE_DOORS_SPECIAL_SECTION_LIST: SpecialDoorStructure[] = [
  {
    name: 'Технические',
    text: 'Для служебных и\u00A0хозяйственных помещений',
    alt: 'Технические двери',
    imgSrc: `${ENTRANCE_DOORS_CDN_PATH}/special/tekhnicheskie.jpg/tekhnicheskie.jpg`,
  },
  {
    name: 'Тамбурные',
    text: 'Для дополнительной звукоизоляции, тепла и\u00A0защиты',
    alt: 'Тамбурные двери',
    imgSrc: `${ENTRANCE_DOORS_CDN_PATH}/special/tamburnye.jpg/tamburnye.jpg`,
  },
  {
    name: 'Бронированные',
    text: 'Для высоких стандартов безопасности',
    alt: 'Бронированные двери',
    imgSrc: `${ENTRANCE_DOORS_CDN_PATH}/special/bronirovannye-new.jpg/bronirovannye-new.jpg`,
  },
  {
    name: 'Противопожарные',
    text: 'Для соблюдения мер пожарной безопасности',
    alt: 'Противопожарные двери',
    imgSrc: `${ENTRANCE_DOORS_CDN_PATH}/special/protivopozharnye.jpg/protivopozharnye.jpg`,
  },
  {
    name: 'Эвакуационные',
    text: 'Для лучшей защиты от\u00A0дыма и\u00A0газа на\u00A0путях эвакуации',
    alt: 'Эвакуационные двери',
    imgSrc: `${ENTRANCE_DOORS_CDN_PATH}/special/evakuacionnye.jpg/evakuacionnye.jpg`,
  },
  {
    name: 'Шумоизолированные',
    text: 'Для дополнительной звукоизоляции\u00A0\u2014 от\u00A030\u00A0дБ и\u00A0выше',
    alt: 'Шумоизолированные двери',
    imgSrc: `${ENTRANCE_DOORS_CDN_PATH}/special/shumoizolirovannye.jpg/shumoizolirovannye.jpg`,
  },
];
